import { memo } from "react"
import { Link } from "react-router-dom"

function OurDoctorBanner(){
    return (<>
    <div className="ourdorbanner">
        <div>
            <div className="bannertia">
                <h3>Our Doctor</h3>
            </div>
            <div className="bannersubme">
                <Link className="bannerli"><h6>Home</h6></Link>
                <h6 className="bannersla"> / </h6>
                <h6>Our Doctor</h6>
            </div>
        </div>
    </div>
    </>)
}
export default memo(OurDoctorBanner)